import yup from './yup'
import moment from 'moment'

export const typesOfEvents = [
  {
    id: 'standalone',
    name: 'Standalone'
  },
  {
    id: 'haveTalks',
    name: 'Contains Talks'
  },
  {
    id: 'haveSessions',
    name: 'Contains Sessions'
  }
]

export const eventFormSchema = yup.object().shape({
  cardStyle: yup.string('Event Card Style').required().label('Card color'),
  eventType: yup
    .string()
    .label('Event Type')
    .oneOf(typesOfEvents.map((event) => event.id))
    .required(),
  eventVenue: yup.string().label('Venue').required(),
  startDate: yup.date().label('Start Date').required().typeError('Invalid date'),
  endDate: yup
    .date()
    .typeError('Invalid date')
    .label('End date')
    .test(
      'Date Check',
      { errType: 'Date', msg: 'End date must be after start date.' },
      function (value) {
        const startDate = moment(this.parent.startDate)
        const endDate = moment(value)
        return endDate.isSameOrAfter(startDate, 'date')
      }
    )
    .test(
      'Time Check',
      { errType: 'Time', msg: 'End Time must be after start Time.' },
      function (value) {
        const startDate = moment(this.parent.startDate)
        const endDate = moment(value)
        return endDate.isSameOrAfter(startDate)
      }
    )
    .required(),
  moderators: yup.array().label('Moderators'),
  isClickable: yup.bool().label('Is Clickable'),
  isPosterSession: yup.bool().label('Is Poster Session'),
  keynotes: yup
    .string()
    .label('Keynotes')
    .when(['eventType', 'isClickable'], (eventType, isClickable) => {
      return eventType === 'standalone' && isClickable
        ? yup.string().label('Keynotes').trimmedRequired('Keynotes is required')
        : yup.string().label('Keynotes')
    }),
  sponsorId: yup.array().label('Sponsor Id').nullable(),
  title: yup.string().label('Title').trimmedRequired('Event Title is required'),
  havePolls: yup.string().oneOf(['yes', 'no']),
  speakerId: yup.mixed().when('havePolls', {
    is: 'yes',
    then: yup.string().label('Speaker').nullable().required()
  }),
  pollId: yup.mixed().when('havePolls', {
    is: 'yes',
    then: yup.string().label('Associated Poll').nullable().required()
  })
})
